interface UserDataRowProps {
  caption: string;
  value?: string;
  noLine?: boolean;
}

export function UserDataRow({ caption, value }: UserDataRowProps) {
  return (
    <>
      <div className="flex items-center gap-5">
        <p className="font-semibold capitalize">{caption}</p>
        <p>{value || '-'}</p>
      </div>
      <hr className="col-span-2 w-full border-b last-of-type:hidden" />
    </>
  );
}
